const T_PREFIX = 'lastmile_management.shipping_costs.validation'

/**
 * Shared dry-run outcome view for both bulk cost wizards: a request-level error, a
 * "looks good" banner, or a table of per-row validation errors from the backend.
 */
export const CostValidationResult = ({ validation, error, t }) => {
  if (error) {
    return <div className="rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800">{t(`${T_PREFIX}.request_failed`)}</div>
  }

  if (!validation) return null

  // Both per-row errors and prerequisite errors (e.g. a missing/invalid xdock binding on create)
  // count — showing only row_errors made a prerequisite-only failure render as "0 errors, fix them".
  const errors = [...(validation.row_errors || []), ...(validation.prerequisites_errors || [])]

  if (errors.length === 0) {
    return <div className="rounded-md border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-800">{t(`${T_PREFIX}.valid`)}</div>
  }

  return (
    <div className="rounded-md border border-red-200 bg-red-50 p-3">
      <p className="mb-2 text-sm font-medium text-red-800">{t(`${T_PREFIX}.invalid`, { count: errors.length })}</p>
      <div className="max-h-48 overflow-y-auto">
        <table className="min-w-full text-xs">
          <thead>
            <tr className="text-left text-red-700">
              <th className="px-2 py-1">{t(`${T_PREFIX}.row`)}</th>
              <th className="px-2 py-1">{t(`${T_PREFIX}.message`)}</th>
            </tr>
          </thead>
          <tbody>
            {errors.map((re, i) => (
              <tr key={i} className="text-red-800">
                {/* Backend `row` is 0-based; the grid numbers rows from 1, so display row + 1.
                    Prerequisite errors carry no row (fall back to id / zone / position). */}
                <td className="px-2 py-1 align-top font-mono">{typeof re.row === 'number' ? re.row + 1 : (re.id ?? re.zone ?? i + 1)}</td>
                <td className="px-2 py-1">{re.message}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
